import { render, staticRenderFns } from "./PrescriptionsIcon.vue?vue&type=template&id=42daaaad&scoped=true&"
import script from "./PrescriptionsIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PrescriptionsIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42daaaad",
  null
  
)

export default component.exports